export default function Portfolio(){
    return(
        <div className="container pt-3 pb-3">
            <h2 style={{color: "#bb790f"}}>CORPORATE PORTFOLIO</h2>
            <ol>
                <li><p style={{fontWeight: 800, margin:0}}>LAHORE ELECTRIC SUPPLY COMPANY (LESCO)</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>ORANGE LINE METRO RAIL</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>MAPLE LEAF CEMENT FACTORY LIMITED</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>DASTGYR TECHNOLOGIES PRIVATE LIMITED</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>STATE LIFE INSURANCE COMPANY</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>ALLIED BANK LIMITED</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>NATIONAL BANK OF PAKISTAN</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>BANK ALFALAH LIMITED</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>MCB BANK LIMITED</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>UTILITY STORE CORPORATION OF PAKISTAN</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>PUNJAB HEALTHCARE COMMISSION (EXTERNAL CONSULTANT)</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>LAMBDA ENGINEERING COMPANY (LEC)</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>ALPHA CONSTRUCTION</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>ALPHA GREEN AGRO CHEMICALS</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>QASWA PETROLEUM PRIVATE LIMITED</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>ISMILE DENTAL SOFTWARE PAKISTAN</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>ACME ENTERPRISES</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>AL-WAZIR POLYMER</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>HOMEMADE & CO.</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>DUKAAN BY HOMEMADE</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>CASA MARKETING PRIVATE LIMITED</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>AL-GHANI REAL ESTATE</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>ALMAS PROPERTIES</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>5TH DIMENTION</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>LAHORE MARATHON</p></li>
                <li><p style={{fontWeight: 800, margin:0}}>HAZ HANDICRAFTS</p></li>
        
            </ol>
        </div>
    )
}